import { lazy, Suspense } from "react";
import NavDock from "@/components/landing/NavDock";
import Hero from "@/components/landing/Hero";

// Below-fold sections — lazy loaded to reduce initial bundle size
const ChaosTax       = lazy(() => import("@/components/landing/ChaosTax"));
const VisionMission  = lazy(() => import("@/components/landing/VisionMission"));
const Belief         = lazy(() => import("@/components/landing/Belief"));
const WhyIntelpreneur = lazy(() => import("@/components/landing/WhyIntelpreneur"));
const Services       = lazy(() => import("@/components/landing/Services"));
const Marquee        = lazy(() => import("@/components/landing/Marquee"));
const FounderLetter  = lazy(() => import("@/components/landing/FounderLetter"));
const Contact        = lazy(() => import("@/components/landing/Contact"));
const Footer         = lazy(() => import("@/components/landing/Footer"));

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative min-h-screen bg-bc text-thinair antialiased">
      <NavDock />
      <Hero />
      <Suspense fallback={null}>
        <ChaosTax />
        <VisionMission />
        <Belief />
        <WhyIntelpreneur />
        <Services />
        <Marquee />
        {/* <Scanner /> */}
        <FounderLetter />
        <Contact />
        <Footer />
      </Suspense>
    </main>
  );
}
